import NavigationBar from "components/NavigationBar";
import { WorkflowOrganizer } from "components/workflows/WorkflowOrganizer";
import { useParams } from "react-router-dom";


const WorkflowsPage: React.FC = () => {

    const { artistId } = useParams<string>();

    if (!artistId){
        console.log("not found");
        return <h2>Not found!</h2>
    }

    return <>
        <div style={{marginLeft: '30px'}}>
        <WorkflowOrganizer ownerId={artistId} />
        </div>
    </>

}

export default WorkflowsPage;